import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class DeviceMessage implements ISerialize {
    public Time: Date;

    public TypeText: string | null;

    public Value: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Time?: Date; TypeText?: string | null; Value?: string | null }) {
        this.Time = values.Time ?? new Date('1970-01-01T00:00:00.000');

        this.TypeText = values.TypeText ?? '';

        this.Value = values.Value ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Time": ${'"' + formatDateIso(this.Time) + '"'}` +
            ',' +
            `"TypeText": ${JSON.stringify(this.TypeText)}` +
            ',' +
            `"Value": ${JSON.stringify(this.Value)}` +
            '}'
        );
    }

    /**
     * Creates an instance of DeviceMessage from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Time?: Date; TypeText?: string | null; Value?: string | null }): DeviceMessage {
        return new DeviceMessage(values);
    }

    public static _FromServerJson(json: any): DeviceMessage {
        return new DeviceMessage({
            Time: json.Time instanceof Date ? json.Time : new Date(json.Time),
            TypeText: json.TypeText ?? '',
            Value: json.Value ?? '',
        });
    }

    /**
     * Creates an instance of DeviceMessage from another instance of DeviceMessage.
     * @param other The DeviceMessage you want to clone
     * @returns A cloned DeviceMessage
     */
    public static FromOther(other: DeviceMessage): DeviceMessage {
        return DeviceMessage._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DeviceMessage.FromOther(this);
    }

    static NAME_OF_CLASS = 'DeviceMessage';
}
